'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Rating", {
    enumerable: true,
    get: function() {
        return Rating;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useRating = require("./useRating");
const _renderRating = require("./renderRating");
const _useRatingStylesstyles = require("./useRatingStyles.styles");
const _useRatingContextValues = require("./useRatingContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Rating = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useRating.useRating_unstable)(props, ref);
    const contextValues = (0, _useRatingContextValues.useRatingContextValues)(state);
    (0, _useRatingStylesstyles.useRatingStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useRatingStyles_unstable')(state);
    return (0, _renderRating.renderRating_unstable)(state, contextValues);
});
Rating.displayName = 'Rating';
